export default function SoftwareTable() {
    return (
        <div>
            <table>
                <thead>
                <tr>
                    <th>Subdomain</th>
                    <th>Favorites</th>
                    <th>Worked before</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Graphic Design</td>
                    <td>Pixelmator Pro, Affinitiy Designer, Procreate</td>
                    <td>Photoshop, Illustrator</td>
                </tr>
                <tr>
                    <td>Video Editing</td>
                    <td>Final Cut Pro, Motion</td>
                    <td>Premiere Pro, After Effects</td>
                </tr>
                <tr>
                    <td>3D Modeling</td>
                    <td>Blender, Fusion</td>
                    <td>SOLIDWORKS</td>
                </tr>
                <tr>
                    <td>Music Production</td>
                    <td>FL Studio</td>
                    <td>Logic Pro</td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}